import { LoanFormData, FormErrors } from '../types';
import i18n from '../i18n/config';

export const validateForm = (formData: Partial<LoanFormData>): FormErrors => {
  const errors: FormErrors = {};
  
  // Validate First Name
  if (!formData.firstName) {
    errors.firstName = i18n.t('form.validation.required', { field: i18n.t('form.fields.first_name') });
  } else if (formData.firstName.length < 2) {
    errors.firstName = i18n.t('form.validation.too_short', { field: i18n.t('form.fields.first_name'), count: 2 });
  }
  
  // Validate Last Name
  if (!formData.lastName) {
    errors.lastName = i18n.t('form.validation.required', { field: i18n.t('form.fields.last_name') });
  } else if (formData.lastName.length < 2) {
    errors.lastName = i18n.t('form.validation.too_short', { field: i18n.t('form.fields.last_name'), count: 2 });
  }
  
  // Validate Personal Code
  if (!formData.personalCode) {
    errors.personalCode = i18n.t('form.validation.required', { field: i18n.t('form.fields.personal_code') });
  } else if (!/^\d{6}-\d{5}$/.test(formData.personalCode)) {
    errors.personalCode = i18n.t('form.validation.personal_code');
  }
  
  // Validate Email
  if (!formData.email) {
    errors.email = i18n.t('form.validation.required', { field: i18n.t('form.fields.email') });
  } else {
    // const allowedDomains = ['@gmail.com', '@inbox.lv', '@apollo.lv', '@tvnet.lv', '@hotmail.com', '@yahoo.com', '@mail.ru'];
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const email = formData.email.toLowerCase();
    const isValidFormat = emailRegex.test(email);
    // const hasAllowedDomain = allowedDomains.some(domain => email.endsWith(domain));
    
    if (!isValidFormat) {
      errors.email = i18n.t('form.validation.email');
    }
  }
  
  // Validate Phone
  if (!formData.phone) {
    errors.phone = i18n.t('form.validation.required', { field: i18n.t('form.fields.phone') });
  } else if (!/^\+?[0-9]{8,14}$/.test(formData.phone)) {
    errors.phone = i18n.t('form.validation.phone');
  }

  // Validate City
  if (!formData.city) {
    errors.city = i18n.t('form.validation.required', { field: i18n.t('form.fields.city') });
  } else if (formData.city.length < 2) {
    errors.city = i18n.t('form.validation.too_short', { field: i18n.t('form.fields.city'), count: 2 });
  }

  if (!formData.declaredAddress?.trim()) {
    errors.declaredAddress = i18n.t('form.validation.address');
  }

  if (!formData.addressesMatch && !formData.facticalAddress?.trim()) {
    errors.facticalAddress = i18n.t('form.validation.address');
  }
  
  if (!formData.addressesMatch && !formData.facticalAddress) {
    errors.facticalAddress = i18n.t('form.validation.address');
  } else if (!formData.addressesMatch && formData.facticalAddress && formData.facticalAddress.length < 5) {
    errors.facticalAddress = i18n.t('form.validation.address');
  }
  
  // Validate Bank Account
  if (formData.bankAccount && !/^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{7}([A-Z0-9]?){0,16}$/.test(formData.bankAccount)) {
    errors.bankAccount = i18n.t('form.validation.bank_account');
  }
  
  // Validate Terms
  if (!formData.agreeToTerms) {
    errors.agreeToTerms = i18n.t('form.validation.terms_required');
  }

  // Validate Family Status
  if (!formData.familyStatus) {
    errors.familyStatus = i18n.t('form.validation.required', { field: i18n.t('form.fields.family_status') });
  }

  // Validate Job Type
  if (!formData.jobType) {
    errors.jobType = i18n.t('form.validation.required', { field: i18n.t('form.fields.job_type') });
  }
  
  return errors;
};

export const isFormValid = (errors: FormErrors): boolean => {
  return Object.keys(errors).length === 0;
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatPeriod = (months: number): string => {
  return i18n.t('form.months', { count: months });
};